import { render, staticRenderFns } from "./NbDropdownAdd.vue?vue&type=template&id=72c3654e&scoped=true"
import script from "./NbDropdownAdd.vue?vue&type=script&lang=js"
export * from "./NbDropdownAdd.vue?vue&type=script&lang=js"
import style0 from "./NbDropdownAdd.vue?vue&type=style&index=0&id=72c3654e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c3654e",
  null
  
)

export default component.exports